import { CheckCircle, XCircle } from "react-bootstrap-icons";
import { toast } from "react-toastify";
 
const Alert = (type, message) =>{
    switch (type) {
        case 'warning':
            return toast.warning(message, {className: 'toast-warn'})
        case 'error':
            return toast.error(message, {className: 'toast-err'}, { icon: <XCircle></XCircle> });
        case 'success':
            return toast.success(message, {className: 'toast-success'},{icon:<CheckCircle></CheckCircle>});
        case 'info':
            return toast.info(message, {className: 'toast-info'},{theme: 'colored', style: { 'background': '#f9f2f6 !important', 'color': '#707070 !important'}})
        case 'dark':
            return toast.dark(message , {className: 'toast-dark'})
        default:
            return toast(message)
    }
}
 
export default Alert;
 